<template>
  <modal title="Sorun Bildir" size="lg">
    <template #content>
      <load-area v-if="hotels == null || users == null"></load-area>
      <Form
        method="dialog"
        v-slot="{ errors }"
        class="floating-labels p-1rem row align-items-start"
        ref="form"
        v-if="hotels != null && users != null"
      >
        <formGroup
          :title="'From'"
          v-model="model.From"
          :errors="errors"
          @keydown.enter="save"
          :rules="{ required: true, email: true }"
        >
        </formGroup>
        <formGroupTag
          :title="'To'"
          v-model="model.To"
          :errors="errors"
          :rules="{ required: true }"
        >
        </formGroupTag>
        <div>
          <div class="row">
            <div class="col-6">
              <selectBox
                :title="'Otel'"
                class="searchOl"
                :isTitle="false"
                :as="'select'"
                v-model="selectedHotels"
                :errors="errors"
              >
                <template #search>
                  <input
                    type="text"
                    placeholder="Hotel Search..."
                    class="form-control small"
                    v-model="searchHotels"
                  />
                </template>
                <template #inputCustom>
                  <template v-for="item in hotels">
                    <li
                      class="myCheckBox"
                      :key="item.Name"
                      v-if="
                        item.Name.toLowerCase().indexOf(
                          searchHotels.toLowerCase()
                        ) > -1
                      "
                    >
                      <input
                        type="checkbox"
                        class="filled-in chk-col-teal"
                        :checked="selectedHotels.indexOf(item.Name) > -1"
                      />
                      <label
                        :for="'hotel' + item.Name"
                        @click="changeHotelsInput(item.Name)"
                      >
                        {{ item.Name }}
                      </label>
                    </li>
                  </template>
                </template>
              </selectBox>
            </div>
            <div class="col-6">
              <selectBox
                :title="'Otel'"
                class="searchOl"
                :isTitle="false"
                :as="'select'"
                v-model="selectedUsers"
                :errors="errors"
              >
                <template #search>
                  <input
                    type="text"
                    placeholder="User Search..."
                    class="form-control small"
                    v-model="searchUsers"
                  />
                </template>
                <template #inputCustom>
                  <template v-for="item in users">
                    <li
                      class="myCheckBox"
                      :key="item.Name"
                      v-if="
                        item.Name.toLowerCase().indexOf(
                          searchUsers.toLowerCase()
                        ) > -1
                      "
                    >
                      <input
                        type="checkbox"
                        class="filled-in chk-col-teal"
                        :checked="selectedUsers.indexOf(item.Email) > -1"
                      />
                      <label
                        :for="'hotel' + item.Name"
                        @click="changeUsersInput(item.Email)"
                      >
                        {{ item.Name }}
                      </label>
                    </li>
                  </template>
                </template>
              </selectBox>
            </div>
          </div>
        </div>
        <formGroupTag
          :title="'Cc'"
          v-model="model.Cc"
          :errors="errors"
          :rules="{ required: true }"
        >
        </formGroupTag>
        <formGroup
          :title="'Subject'"
          v-model="model.Subject"
          :errors="errors"
          @keydown.enter="save"
          :rules="{ required: true }"
        >
        </formGroup>
        <formGroup
          :title="'Body'"
          as="textarea"
          rows="5"
          v-model="model.Body"
          :errors="errors"
          :rules="{ required: true }"
        >
        </formGroup>
      </Form>
    </template>
    <template #foot>
      <Btn class="btn-success btn-md" @click="save" :process="process"
        >Send Mail</Btn
      >
    </template>
  </modal>
</template>

<script>
import { mapState } from "vuex";
import selectBox from "@/components/formGroup/selectBox";
export default {
  name: "SendAccessProblem",
  components: { selectBox },
  props: ["setModel"],
  data() {
    return {
      hotels: null,
      searchHotels: "",
      selectedHotels: [],
      users: null,
      searchUsers: "",
      selectedUsers: [],
      model: {
        From: "",
        SenderName: "Resbox Mail Services",
        Subject: "Asyasoft Servis Sorunu",
        Body: "",
        To: [
          // "iturkkan@asyasoft.com.tr",
          "destek@asyasoft.com.tr",
        ],
        Cc: [],
      },
      process: false,
    };
  },
  created() {
    this.model.From = this.user.Email;
    this.model.Cc = [
      "support@resbox.com"
    ];
    this.model.Cc = this.model.Cc.filter((x) => x != this.user.Email);
    this.$appAxiosAdmin
      .get(`CustomerHotels/` + this.setModel.Id)
      .then((response) => {
        this.hotels = response.data;
      });
    this.$appAxiosAdmin
      .get(`Customers/` + this.setModel.Id + `/Users`)
      .then((response) => {
        this.users = response.data;
      });
  },
  watch: {},
  methods: {
    changeHotelsInput(item) {
      if (this.selectedHotels.indexOf(item) > -1) {
        this.selectedHotels = this.selectedHotels.filter((x) => {
          return x != item;
        });
      } else {
        this.selectedHotels.push(item);
      }

      let hotels = "";
      if (this.selectedHotels.length > 1) {
        this.selectedHotels.forEach((element, index) => {
          if (index < this.selectedHotels.length - 1) {
            if (hotels == "") {
              hotels += element;
            } else {
              hotels += ", " + element;
            }
          } else {
            hotels += " ve " + element;
          }
        });
        this.model.Body =
          "Merhabalar, \n" +
          hotels +
          " otellerimizde asyasoft servisinden cevap alınamıyor. Konu ile ilgili desteğinizi rica ederiz.";
      } else if (this.selectedHotels.length == 1) {
        this.model.Body =
          "Merhabalar, \n" +
          this.selectedHotels[0] +
          " otelimizde asyasoft servisinden cevap alınamıyor. Konu ile ilgili desteğinizi rica ederiz.";
      }
    },
    changeUsersInput(item) {
      if (this.selectedUsers.indexOf(item) > -1) {
        this.selectedUsers = this.selectedUsers.filter((x) => {
          return x != item;
        });
      } else {
        this.selectedUsers.push(item);
      }

      this.model.Cc = [];
      let we = [
        "ali@resbox.com",
        "onur@resbox.com",
        "turgut@resbox.com",
        "yasin@resbox.com",
      ];
      we = we.filter((x) => x != this.user.Email);
      if (this.selectedUsers.length > 0) {
        this.selectedUsers.forEach((element) => {
          this.model.Cc.push(element);
        });
        this.model.Cc = [...this.model.Cc, ...we];
      } else {
        this.model.Cc = we;
      }
    },
    save() {
      this.$refs.form.validate().then((valid) => {
        if (valid.valid) {
          this.process = true;
          this.$appAxiosAdmin
            .post(`PMS/SendAccessProblem`, {
              ...this.model,
              Body: this.model.Body.replaceAll("\n", "<br>"),
            })
            .then(() => {
              this.process = false;
              this.$swal({
                icon: "success",
                title: "Success",
                text: "Mail sent successfully.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
              this.$emit("close");
            })
            .catch((err) => {
              this.process = false;
              this.$isError(err);
            });
        }
      });
    },
  },
  computed: {
    ...mapState(["user"]),
  },
};
</script>

<style></style>
